import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse,  StateTrackedData } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { MDMMIlestoneModelRef, MDMMilestoneStore } from "../domain/mdm-milestone.model";

export const createMDMMilestone = createAsyncThunk<void, any>(
  "mdmMilestone/createMDMMilestone",
  async (payload: any) => {
    const url = `${AppConstants.api}/milestoneMDM`;
    const response = await api.post<ApplicationResponse<any>>(
      url,
      payload
    );
    return response.data.data || [];
  }
);
export const updateMDMMilestone = createAsyncThunk<void, any>(
  "mdmMilestone/updateMDMMilestone",
  async (payload: any) => {
    const url = `${AppConstants.api}/milestoneMDM`;
    const response = await api.put<ApplicationResponse<any>>(
      url,
      payload
    );
    return response.data.data || [];
  }
);
export const deleteMDMMilestone = createAsyncThunk(
  "mdmMilestone/deleteMDMMilestone",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/milestoneMDM?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchMDMMilestoneList = createAsyncThunk<any[], void>(
    "mdmMilestone/fetchMDMMilestone",
    async () => {
          const response = await api.get<ApplicationResponse<MDMMIlestoneModelRef[]>>(`${AppConstants.api}/milestoneMDM`)
        return response.data.data || []
    }
);

const mdmMilestoneSlice = createSlice({
  name: "mdmMilestone",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as MDMMilestoneStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMDMMilestoneList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchMDMMilestoneList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchMDMMilestoneList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});

export default mdmMilestoneSlice.reducer;


